import selectedFiltersStyles from '../StatusBar/styles/SelectedFlters.module.scss';
import styles from './FilterByTags.module.scss';
import React from 'react';
import { clsx } from '../../../utils/clsx';
const skeletonWidths = [6, 8, 7, 6, 9, 8, 10, 6, 8, 7];
export const FilterByTagsSkeleton = () => (React.createElement("div", { className: styles.container },
    React.createElement("ul", { className: clsx('list:none d:grid gaf:column jc:start d:flex:xl-up fxw:wrap:xl-up ov:h', selectedFiltersStyles.wrapper) }, skeletonWidths.map((w, i) => (React.createElement("li", { key: i, className: selectedFiltersStyles.itemWrapper },
        React.createElement("span", { className: clsx('skeleton bdrs:2 d:block', selectedFiltersStyles.item), style: { width: `${w}em` } })))))));
